import React from "react";
import heroImage from "../assets/img/Rectangle 46.png";



const Hero = () => {
  return (
   <section
  className="position-relative"
  style={{
    zIndex: 99,
    margin: "0 auto",
    overflow: "hidden",
  }}
>
   <img
        src={heroImage}
        alt="Wind farm"
        className="img-fluid hero-img" // Bootstrap responsive image
        style={{
          width: "100%",       // takes full width of parent
          height: "auto",      // scales proportionally
          objectFit: "cover",  // keeps good cropping when needed
          display: "block",
        }}
      />
</section>

  );
};

export default Hero;
